import NewsTipNewspaper from './NewsTipNewspaper'

export default NewsTipNewspaper
